export default __webpack_public_path__ + "static/why-forex-2691594d57f6f425fb76ce4aeddb3838.jpg";